import { render, staticRenderFns } from "./PptConfig.vue?vue&type=template&id=b68a9c0a&"
import script from "./PptConfig.vue?vue&type=script&lang=js&"
export * from "./PptConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/components/PptConfig.vue"
export default component.exports